
export default interface ISectionCondition {
    id: string | undefined;
    sectionId: string | undefined;
    rules: ISectionConditionRole[];
}

export interface ISectionConditionRole {
    xItem: IComponentValue;
    operator: OperatorType;
    yItem?: IComponentValue;
    value?: any;
}

export interface IComponentValue {
    id: string;
    prop: ComponentProp;
}
export enum ComponentProp {
    FILLED = 1,
    COUNT = 2,
    VALUE = 3
}
export enum OperatorType {
    Contains = 1,
    NotContains = 2,
    Equals = 3,
    NotEquals = 4,
    GreaterThan = 5,
    GreaterOrEqualsThan = 6,
    LessThan = 7,
    LessOrEqualsThan = 8
}